// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0b899612] .paypal-button{padding:.4rem .4rem !important;margin-bottom:.3rem}.gateway-image[data-v-0b899612]{margin-left:.2rem;padding-bottom:.2rem}.gateway-image.QUANTUM[data-v-0b899612]{padding-bottom:0}.gateway-image.BEANSTREAM[data-v-0b899612],.gateway-image.AUTHORIZE_NET[data-v-0b899612]{padding-bottom:.3rem}", ""]);
// Exports
module.exports = exports;
